import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { FileText, GraduationCap, MessagesSquare, CalendarClock, Mail, Users } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);
  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  const cards = [
    { label: "Blog Posts", value: stats?.blog, icon: FileText },
    { label: "Courses", value: stats?.courses, icon: GraduationCap },
    { label: "Testimonials", value: stats?.testimonials, icon: MessagesSquare },
    { label: "Total Bookings", value: stats?.consultations, icon: CalendarClock },
    { label: "Pending Bookings", value: stats?.pending_consultations, icon: CalendarClock },
    { label: "Enquiries", value: stats?.enquiries, icon: Mail },
    { label: "Unhandled", value: stats?.unhandled_enquiries, icon: Mail },
    { label: "Newsletter Subs", value: stats?.newsletter, icon: Users },
  ];

  return (
    <div data-testid="admin-dashboard">
      <h1 className="font-serif text-4xl mb-2">Dashboard</h1>
      <p className="text-foreground/60 mb-8">Welcome back. Here is the pulse of your platform.</p>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {cards.map((c) => (
          <div key={c.label} data-testid={`stat-${c.label.toLowerCase().replace(/\s/g,'-')}`} className="rounded-2xl border border-foreground/10 p-5 bg-background">
            <c.icon className="w-5 h-5 text-[#D4AF37] mb-3" />
            <div className="text-3xl font-serif">{c.value ?? "—"}</div>
            <div className="text-xs uppercase tracking-[0.2em] text-foreground/60 mt-1">{c.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
